import React from 'react';

function MobilePhoneIcon ({ width = 18, height = 30, ...props}) {
  return (
    <svg width={width} height={height} {...props} viewBox="0 0 18 30">
      <g>
        <path d="M17,26.5 L17,3.5 C17,2.12614237 15.8738576,1 14.5,1 L3.5,1 C2.12614237,1 1,2.12614237 1,3.5 L1,26.5 C1,27.8738576 2.12614237,29 3.5,29 L14.5,29 C15.8738576,29 17,27.8738576 17,26.5 Z M18,26.5 C18,28.4261424 16.4261424,30 14.5,30 L3.5,30 C1.57385763,30 0,28.4261424 0,26.5 L0,3.5 C0,1.57385763 1.57385763,0 3.5,0 L14.5,0 C16.4261424,0 18,1.57385763 18,3.5 L18,26.5 Z" />
        <path d="M0.5,6.5 C0.223857625,6.5 0,6.27614237 0,6 C0,5.72385763 0.223857625,5.5 0.5,5.5 L17.5,5.5 C17.7761424,5.5 18,5.72385763 18,6 C18,6.27614237 17.7761424,6.5 17.5,6.5 L0.5,6.5 Z" />
        <path d="M0.5,23.5 C0.223857625,23.5 0,23.2761424 0,23 C0,22.7238576 0.223857625,22.5 0.5,22.5 L17.5,22.5 C17.7761424,22.5 18,22.7238576 18,23 C18,23.2761424 17.7761424,23.5 17.5,23.5 L0.5,23.5 Z" />
        <path d="M6.5,4 C6.22385763,4 6,3.77614237 6,3.5 C6,3.22385763 6.22385763,3 6.5,3 L11.5,3 C11.7761424,3 12,3.22385763 12,3.5 C12,3.77614237 11.7761424,4 11.5,4 L6.5,4 Z" />
        <path d="M10,27 C10,27.552 9.553,28 9,28 C8.447,28 8,27.552 8,27 C8,26.448 8.447,26 9,26 C9.553,26 10,26.448 10,27 Z" />
      </g>
    </svg>
  );
}

export default MobilePhoneIcon;
